import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import Features from './Features';
const Menu = () => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [openCloseOnOff, setOpenCloseOnOff] = useState(false);
   const [backliteOnOff, setBackliteOnOff] = useState(false);

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [widthUpdate, setwidthUpdate] = useState(false);
   const [updatefeatureType,setupdatedfeatureType]=useState('wwan');
   const [productTitle, setProductTitle] = useState([]);
   // setwidthUpdate(window.mob)
   let howtoUseD = false;
   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);
            
            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;
            // window.productId = setmydata.productId;
            window.selectedConfig.name = setmydata.productId;
            window.selectedConfig.currentFeatureSubMenuChecked = `menu_id_${setmydata['currentFeatureSubmenuOneChecked']}`
            window.selectedConfig.currentFeatureSubmenuTwoChecked = `menu_id_${setmydata['currentFeatureSubmenuTwoChecked']}`   
            window.preActiveFeatureSubMenuIdOne = `menu_id_${setmydata['currentFeatureSubmenuOneChecked']}`  
            window.preActiveFeatureSubMenuIdTwo = `menu_id_${setmydata['currentFeatureSubmenuTwoChecked']}`   
            window.currentMenuActiveId = `accordion_${setmydata['currentActiveMenu']}` 
            console.log();
            let feature_list;
            let menuData;

            let uiData;

            if (setmydata.menus[window.LangName] == undefined) {
               uiData = setmydata.menus.EN[0];

            } else {
               uiData = setmydata.menus[window.LangName][0];
            }
            window.dataUI = uiData;
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
               feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
            }
            else {
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               var mobProducts = menuData[0].items;
               feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
            }
            setMenuList(menuData);
            setuiDataList(uiData);
            setfeatureMenuList(feature_list);
            setTimeout(() => {
               langTranslationAlignment(menuData);   
            }, 100);

            if(setmydata["accordianClick"]){
               const setAllItems = () => {
                        const allItemsObj = menuData.flatMap((obj) => [
                          obj.id,
                          ...obj.items.map((item) => item.id),
                        ]);
                        setbuttonArray(allItemsObj);
                      };
                      setAllItems();
                      const setAllAccordion = () => {
                        const allAccordionObj = menuData.flatMap((obj) => [
                          obj,
                          ...obj.items.map((item) => item),
                        ]);
                        setbuttonArrayObjectList(allAccordionObj);
                      };
                      setAllAccordion();
              
            }else{
               menuData.map((menu) => {
                        menu.items.map(item => {
                           if (item.id !== undefined) {
                              setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                              setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
                           }
                        })
                     })
            }
         });
   }

   const langTranslationAlignment = (menuData) => {
      if (window.dataUI) {
         document.querySelector('title').innerHTML = window.dataUI.ui.projectTitle;
         document.getElementById('move_text').innerHTML = window.dataUI.ui.move;
         document.getElementById('rotate_text').innerHTML = window.dataUI.ui.rotate;
         document.getElementById('zoom_text').innerHTML = window.dataUI.ui.zoom;
         document.getElementById('exploreButtton').innerHTML = window.dataUI.ui.exploreProductIn3D;


         if (window.dataUI.ui.langcode == "fr") {
            document.getElementById("rotate_text").style.fontSize = '39px';
         }
         
         if (window.dataUI.ui.langcode == "fr-ca") {
            setTimeout(function () {
               document.querySelector("#rotate_text").style.width = '265px';
               document.querySelector("#rotate_text").style.display = 'inline-block';
            }, 0)
         }

         if (window.dataUI.ui.langcode == "fr-ca" || window.dataUI.ui.langcode == "fr" || window.dataUI.ui.langcode == "de" || window.dataUI.ui.langcode == "nl") {
            if (document.getElementById("mobHowToUseText") !== null) {
               document.getElementById("mobHowToUseText").style.fontSize = "30px";
            }
            if (document.getElementById("move_how_to_use") !== null) {
               document.getElementById("move_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("rotate_how_to_use") !== null) {
               document.getElementById("rotate_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("zoom_how_to_use") !== null) {
               document.getElementById("zoom_how_to_use").style.fontSize = "19px";
            }
         }
         if (window.dataUI.ui.langcode == "it") {
            if (document.getElementById("mobHowToUseText") !== null) {
               document.getElementById("mobHowToUseText").style.top = "-43%";
            }
           
         }

        

      
         
         if (window.dataUI.ui.langcode.toLowerCase() === "de" ) {
            document.querySelector(".tooltiptext").style.width = '306px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "ja") {
            document.querySelector(".tooltiptext").style.width = '306px';
            document.querySelector(".tooltiptext").style.top = '-19px';
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "no" || window.dataUI.ui.langcode.toLowerCase() === "es") {
            setTimeout(function () {
               document.querySelector("#rotate_text").style.display = 'inline-block';
            }, 0);

         }

         if (window.mob && window.innerHeight > window.innerWidth) {
            if (window.dataUI.ui.langcode == "es") {
               setTimeout(function () {
                  document.querySelector("#zoom_text").style.textAlign = 'left';
                  document.querySelector("#move_text").style.textAlign = 'left';
                  document.querySelector("#rotate_text").style.textAlign = 'left';
                  document.querySelector("#zoom_text").style.width = '200px';
                  document.querySelector("#zoom_text").style.display = 'inline-block';
               }, 0);

            }
          
            if (window.dataUI.ui.langcode.toLowerCase() == "fr-ca" || window.dataUI.ui.langcode.toLowerCase() == "fr" || window.dataUI.ui.langcode.toLowerCase() == "nl") {
               setTimeout(function () {
                  document.querySelector("#zoom_text").style.fontSize = "37px"
                  document.querySelector("#move_text").style.fontSize = "37px"
                  document.querySelector("#rotate_text").style.fontSize = "37px"
                  document.querySelector("#rotate_text").style.display = 'inline-block';
                  document.querySelector("#rotate_text").style.width = '202px';
               }, 0);

            }
         }


         if (window.mob && window.innerHeight > window.innerWidth || window.isipad && window.innerHeight > window.innerWidth) {

            if (window.dataUI.ui.langcode.toLowerCase() === "de") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';
                  document.querySelector("#mobHowToUseText").style.top = '-17%';
                  document.querySelector("#zoom_how_to_use").style.fontSize = '19px';

               }, 0);
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "de") {
               setTimeout(function () {
                  if (document.getElementById("move_text") !== null) {
                     document.getElementById("move_text").style.fontSize = "33px";
                  }
                  if (document.getElementById("rotate_text") !== null) {
                     document.getElementById("rotate_text").style.fontSize = "33px";
                  }
                  if (document.getElementById("zoom_text") !== null) {
                     document.getElementById("zoom_text").style.fontSize = "33px";
                  }
               }, 0);
            }

            //This is for onload screen for mobile UI
            if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';

                  if (document.getElementById("move_text") !== null) {
                     document.getElementById("move_text").style.fontSize = "30px";
                  }
                  if (document.getElementById("rotate_text") !== null) {
                     document.getElementById("rotate_text").style.fontSize = "30px";
                  }
                  if (document.getElementById("zoom_text") !== null) {
                     document.getElementById("zoom_text").style.fontSize = "30px";
                  }
               }, 0);

            }

            if (window.dataUI.ui.langcode.toLowerCase() === "pl" || window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode.toLowerCase() === "es") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.top = '-16%';
               }, 0);

            }
            // setTimeout(() => {
            //    if (window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode.toLowerCase() === "ja" || window.dataUI.ui.langcode.toLowerCase() === "fr" || window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "nl"){
            //       if (document.getElementById("arMobText") !== null) {
            //       document.getElementById("arMobText").style.fontSize = "11px";
            //       }
            //    }
            // }, 0);
         }
      }
   }
   useEffect(() => {

      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;

   })

   useEffect(() => {
      setTimeout(() => {
         getData();
      }, 1000);

   }, [])

   window.checkWindowSize = function () {
      setwidthUpdate(window.mob)
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }
            }
         }
      }

   }
   const howToUSEClick = (e) => {
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      document.querySelector('#howToUSE').focus();
      if (howtoUseD) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex','-1');
         });
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex','1');
         });
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }

   const closeHandleMenu = (event) => {
      //TabIndex Click Functionality
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex','-1');
         });
         document.querySelector('#howToUseMenu').focus();
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');
         howtoUseD = false;
      }
   };


   const closeHandle = (event) => {
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const accordionMenu = (e) => {
     
      //TabIndex Click Functionality
      //make tabIndex -1
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      subMenuTabIndex1Arr.forEach(ele => {
         ele.setAttribute("tabIndex","-1");
      });

      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      
      myJson.menus.EN.map((menu_Item)=>{
         
         if("accordion_"+ menu_Item['id'] === e.target.closest('.menu').id){
            return window.execute_all(menu_Item);
            
         }
      })

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';
         }
      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {
               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }

         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }
         //TabIndex Click Functionality
         //make tabIndex 1
         let currentTargetAccordion = e.target.closest('.menu.active')
         let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
         let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');
         let subMenuElementArr = [...subMenuElement];
         subMenuElementArr.forEach(ele => {
            ele.setAttribute("tabIndex","1");
         });
      }

      if (orentation === 90) {
         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
      }
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }
   const subMenu = (e) => {

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }
   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }
   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'on';

      } else {
         window.animationStatus = 'off';

      }

   }
   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.animationStatus = 'on';
         document.getElementById("animSwitchValue").checked = true;

      }

   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === true) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob && !window.isipad) {

            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {

            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {

            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }


      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {


               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }


      } else {
         window.animation1SwitchGlobal = 'off';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }
   const handleMenuClick = (menu_object, e) => {

      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      let productType = cameraType;
      
      if(menu_object.sequenceName) window.scene.applySequence(window[menu_object.sequenceName])
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.hidePopUp();
      window.currID = menu_object['id'];

      if (productType == "features" && menu_object['featureType'] != "Fingerprint") {
         window.featureType = menu_object['featureType'];
         if((window.mob || window.isipad) && window.innerWidth < window.innerHeight){
            setupdatedfeatureType( window.featureType);
         }
      }
         window.execute_all(menu_object); 
      setMenuActive(cameraId, cameraType, e);
      window.prevID = menu_object['id'];
      if (orentation === 90) {
         closeHandle();
      }
   }

   const setMenuActive = (menu_id, menu_type, e) => {
      if(menu_type === 'features' && (menu_id === "fpr" || menu_id === "noFpr")){
         const prefprActive = document.querySelector('.radioButton.fprActive'); 
         if(prefprActive){
            prefprActive.classList.remove('fprActive')
            prefprActive.querySelector('input').checked = false;
         }
   
         setTimeout(() => {
            const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
           window.selectedConfig.currentFeatureFPRClick = featureModeBtn.id;
            if(featureModeBtn){
               featureModeBtn.classList.add('fprActive')
               featureModeBtn.querySelector('input').checked = true;
            }   
         }, 300);         
   
      }else if(menu_type === 'features'){   
         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive'); 
         if(prefeatureModeActive){
            prefeatureModeActive.classList.remove('featureModeActive')
            prefeatureModeActive.querySelector('input').checked = false;
         }
   
         setTimeout(() => {
            const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
            window.selectedConfig.currentFeatureClick = featureModeBtn.id;
            if(featureModeBtn){
               featureModeBtn.classList.add('featureModeActive')
               featureModeBtn.querySelector('input').checked = true;
            }
   
            var previousFPRACtive = document.getElementById(window.selectedConfig.currentFeatureFPRClick)            
            if (previousFPRACtive) {
                 previousFPRACtive.classList.add('fprActive');        
            }
         }, 300);
      } 


      let currentClass;
      let preActive;
      var currentActive;
      if (e != undefined) { 
         currentActive = e.target.closest('li.subMenuBtn');
         currentClass = currentActive?.classList[0];
         preActive = document.querySelector('.' + currentClass + '.active');
         if((window.mob || window.isipad) && window.innerHeight > window.innerWidth){
            if(preActive?.id == currentActive?.id){
               setTimeout(() => {
                  currentActive?.classList.remove('active')
               }, 100);
            }else{
               currentActive?.classList.add('active');
               preActive?.classList.remove('active')
            }
         }else{
            preActive?.classList.remove('active');
            currentActive?.classList.add('active');
         }
      } 
      else {
        
         if(document.getElementById('menu_id_' + menu_id) != null){
            currentActive = document.getElementById('menu_id_' + menu_id);
            currentClass = currentActive.classList[0];
            preActive = document.querySelector('.' + currentClass + '.active');
           
            if (preActive != null) {
              preActive.classList.remove('active');
           }
   
                  
           if((window.mob || window.isipad) && window.innerHeight > window.innerWidth){
            if(preActive?.id == currentActive?.id){
               console.log(currentActive,"currentActive")
               setTimeout(() => {
                  currentActive.classList.remove('active')
               }, 100);
            }else{
               currentActive.classList.add('active')
            }
         }else{
            
            currentActive.classList.add('active');
         }
            window.selectedConfig.currentProductClick = currentActive.id;
         }           
      }
   
      window.selectedConfig.currentProductClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }
   let skipNextPreviousPortArrId = ["graphite","platinum"];

   const onPreviousMode = () => {
      window.hidePopUp();
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }

      var prevButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
         prevButton = buttonArray[buttonArray.length - 1];
      } else {

         prevButton = buttonArray[selectedButtonIndex - 1];
      }

      if (prevButton == undefined) { prevButton = buttonArray[buttonArray.length - 1] }

      let result = buttonArrayObjectList.find(object => object.id == prevButton);
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }
      if(window.productType != "colors" ){
         window.storeViewID = result['id']
      }
      window.execute_all(result);
      setMenuActive(result['id'], result['type']);


      return false;

   }
   const onNextMode = () => {
      window.hidePopUp();
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      let cameraName;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
      let finalButtonArray = buttonArray.filter(item => !skipNextPreviousPortArrId.includes(item));
      var nextButton;
      var selectedButtonIndex = finalButtonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         nextButton = finalButtonArray[0];

      } else {
         nextButton = finalButtonArray[selectedButtonIndex + 1];
      }
      if (nextButton === undefined) { nextButton = finalButtonArray[0] }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      // console.log(result)
      if (nextButton === undefined) { nextButton = buttonArray[0] }
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }
      window.execute_all(result);
      setMenuActive(result['id'], result['type']);
      return false;

   }
   const onReset = () => {
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

      window.updateSlider();
      if (!window.AnimComplated) {
         return;
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' ||  window.checkedButton === '' || window.checkedButton === undefined ) {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if(window.checkedButton === 'productView'){           
         window.scene.applySequence(window[window.config.resetSequence]);
      } 
       else if(window.checkedButton === 'features'){
         nextButton = 'FunctionMode'
      }
      else {
         nextButton = window.checkedButton;
      }
      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {         
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
   }
   
   const expandMenu = (menuId) => {
      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');

         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }

      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {

         document.getElementById(menuId).classList.add('active')

         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }

   }
   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }
   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)


   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const TowerClick = (menuData) => {
      window.execute_all(menuData[0].items[0]);
   }

   //This code is for how to use component resize issue
   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90)
      } else {
         setOrentation((item) => {
            return item;
         })
      }


   }
   window.addEventListener('resize', CanvasResizeFunction)
   // console.log(menuList,'menulist-----------')
   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }

   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
               <div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'none' } : {}}>
                  <span className='portraitButtonText'id='arMobText'>{arMob ?? 'See P5525QC Monitor in your space'}</span>
               </div> 
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{howToUSE ?? 'How to use'}</span>
               </div>

               <div id="howToUseMenu" tabIndex="-1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick()
               }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>{howToUSE ?? 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandleMenu} />}
               <div className='accordionContainer'>
                  {
                     menuList.map((list) => {
                           // console.log(list,'list----')
                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="-1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                           </React.Fragment>
                        )
                     })

                  }
               </div>
               <div id="menuFooter">
                 {myJson.QRSupport && <div id="qrCode">
                     <img src='images/qrcode.svg' /> <br />
                     <span className='text'>{QR ?? 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  } 
                  <div id="animation">
                     <span>{ReduceTransitions ?? 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className=''>{onScreenControls ?? 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext ?? 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandleMenu} />
         </div>
      </>
   );
}

export default Menu;